// extracted by mini-css-extract-plugin
export var container = "_du-0";
export var segment = "_du-2";
export var segmentActive = "_du-3";
export var track = "_du-1";